// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__34Qix","search":"Settings_search__1IkYM","filter":"Settings_filter__dv-Zb"};